import React from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";

class UserStats extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props;
  }

  render() {
    const { users, merchants } = this.props;

    return (
      <div>
        <style type="text/css">
          {`
    .btn-flat {
      display: inline;
      background-color: #cdcecf;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #7dc3ae85;
      color: #2f0246;
      border-radius: 8px;
      border: 1px solid teal;  
    }
    `}
        </style>
        <Table className="bg-flat" responsive>
          <thead>
            <tr>
              <th>User ID</th>
              <th>Name</th>
              <th>Merchant</th>
              <th>Email</th>
              <th>Admin</th>
              <th>Driver</th>
              <th>Driver ID</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, i) => {
              const merchant = merchants.merchantStats.find(
                (merch) => merch.id === users[i].merchant_id
              );
              return (
                <tr key={users[i].id}>
                  <td>
                    <Link to={`/users/${users[i].id}`}>{users[i].id}</Link>
                  </td>
                  <td>
                    {users[i].first_name} {users[i].last_name}
                  </td>
                  <td>{merchant ? merchant.name : "Not provided"}</td>
                  <td>{users[i].email}</td>
                  <td>{users[i].admin ? "Admin" : ""}</td>
                  <td>{users[i].driver ? "Driver" : ""}</td>
                  <td>{users[i].driver_id}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withRouter(UserStats);
